import { Typography } from '@mui/material';

import { AlertCard } from '@hapvida/hapvida-core-components';

export function CopartAlert() {
  return (
    <AlertCard
      type="warning"
      content={
        <Typography variant="text">
          Prezado cliente, para melhor atendê-lo,{' '}
          <Typography variant="text" fontWeight={700}>
            disponibilizamos uma prévia da coparticipação realizada até o dia
            anterior a esta consulta.
          </Typography>{' '}
          Destacamos que esta consulta é uma previa, portanto, os valores podem
          sofrer variação em função de atendimento realizado posteriormente a
          esta consulta.
        </Typography>
      }
    />
  );
}
